// --- Cache-busting redirect (must be first) ---
const BUILD_ID = (typeof process !== 'undefined' && process.env?.REACT_APP_BUILD_ID) || 'dev';

(function ensureVersionParam() {
  try {
    const url = new URL(window.location.href);
    const current = url.searchParams.get('v');
    if (current !== BUILD_ID) {
      url.searchParams.set('v', BUILD_ID);
      // Fresh fetch of index.html & bundles
      window.location.replace(url.toString());
    }
  } catch {
    // ignore
  }
})();

// Make this file a module
export { };

// 🔥 Unregister any service workers BEFORE loading the app
(async () => {
  try {
    if ('serviceWorker' in navigator) {
      const hadController = !!navigator.serviceWorker.controller;
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map(r => r.unregister()));

      // If an SW was controlling this page, do a one-time reload so it's detached.
      if (hadController && !sessionStorage.getItem('sw-cleaned')) {
        sessionStorage.setItem('sw-cleaned', '1');
        setTimeout(() => window.location.reload(), 0);
        // Stop bootstrapping on this pass; next load will be clean.
        return;
      }
    }
  } catch (err) {
    console.warn('Service worker cleanup failed:', err);
  }
})();

// Only load React after we've prepared the DOM
import('./react-app')
  .then()
  .catch(err => {
    console.error('Failed to load React app:', err);
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="text-align: center; margin-top: 50px; color: red;">
          <h2>Failed to load application</h2>
          <p>${err instanceof Error ? err.message : String(err)}</p>
          <button onclick="window.location.reload()">Reload</button>
        </div>
      `;
    }
  });

// Prepare the DOM element before React loads
(function prepareDOM() {
  try {
    // Get or create the root element
    let rootElement = document.getElementById('root');

    if (!rootElement) {
      rootElement = document.createElement('div');
      rootElement.id = 'root';
      document.body.appendChild(rootElement);
    }

    // Clear any existing content
    rootElement.innerHTML = `
      <div style="text-align: center; padding: 20px; margin-top: 50px;">
        <h2>Loading Admin Panel...</h2>
        <p>Please wait while the application initializes.</p>
      </div>
    `;

    // Force a layout calculation
    void rootElement.offsetHeight;

  } catch (error) {
    console.error('Failed to prepare DOM:', error);
  }
})();
